import WarningIcon from '@/assets/icons/warning.svg?react';
import Button from '@/components/ui/button/button.component';
import { Dialog, DialogContent, DialogTitle } from '@/components/ui/dialog/dialog.component';
import { useDialogStore } from '@/store/dialog.store';
import { dialogConfirmationTranslations } from './dialog-container.messages';

import { T } from '@/components/i18n/message.i18n.component';
import { cn } from '@/lib/utils';
import { useIntl } from 'react-intl';
import { dialogLocators } from './dialog.locators';

export const DialogContainer = () => {
  const t = useIntl();
  const {
    open,
    title,
    loading,
    type,
    item,
    content,
    fullScreen,
    confirmationText,
    confirmButtonText,
    handleClose,
    handleConfirm,
  } = useDialogStore((state) => ({
    ...state,
    handleClose: state.closeDialog,
    handleConfirm: state.onConfirm,
  }));

  return (
    <Dialog open={open} onOpenChange={handleClose}>
      <DialogContent
        className={cn(
          fullScreen && 'min-w-[calc(1200px)] min-h-[calc(100vh-148px)] max-h-[calc(100vh-48px)] overflow-hidden',
        )}
      >
        <DialogTitle
          className={cn(fullScreen ? 'max-w-[calc(720px)]' : 'max-w-[calc(440px)]')}
          data-testid={dialogLocators.dialogTitle}
        >
          {title || <T {...dialogConfirmationTranslations.confirmTitle} />}
        </DialogTitle>
        {type === 'confirmation' && (
          <>
            <div
              data-testid={dialogLocators.dialogConfirmationDesc}
              className="mb-4 py-4 px-3 bg-system-warning-bg typo-secondary flex flex-row items-center rounded gap-2"
            >
              <span>
                <WarningIcon />
              </span>
              <p className="typo-secondary">
                {confirmationText ||
                  t.formatMessage(dialogConfirmationTranslations.confirmDescription, {
                    item: item.name,
                  })}
              </p>
            </div>
            <div className="flex justify-between">
              <Button data-testid={dialogLocators.dialogConfirmationCloseBtn} variant="secondary" onClick={handleClose}>
                <T {...dialogConfirmationTranslations.backButton} />
              </Button>
              <Button data-testid={dialogLocators.dialogConfirmBtn} loading={loading} onClick={handleConfirm}>
                {confirmButtonText || <T {...dialogConfirmationTranslations.confirmButton} />}
              </Button>
            </div>
          </>
        )}
        {type === 'custom' && content}
      </DialogContent>
    </Dialog>
  );
};
